import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Spacer } from 'app/member/layouts/generic';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import { BlogsView } from './blogs';
import { WordSearchesView } from './word-searches';

const nav_items = [
  { title: 'Blogs', path: '/content/blogs' },
  { title: 'Word searches', path: '/content/word-searches' }
];

export const ContentModule = () => {
  return (
    <PageContentWrapper>
      <SlidingNav nav_items={nav_items} />
      <Spacer multiple={4} />
      <Routes>
        <Route path="/word-searches/*" element={<WordSearchesView />} />
        <Route path="/*" element={<BlogsView />} />
      </Routes>
    </PageContentWrapper>
  );
};
